// Angular Imports
import { NgModule } from '@angular/core';

// This Module's Components
import { PpdLookupComponent } from './ppd-lookup.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BizDatatableModule } from '../biz-datatable/biz-datatable.module';
import { PagesContainersModule } from '../../../../../containers/pages/pages.containers.module';

@NgModule({
    imports: [
        FormsModule, ReactiveFormsModule, CommonModule, BizDatatableModule, PagesContainersModule
    ],
    declarations: [
        PpdLookupComponent,
    ],
    exports: [
        PpdLookupComponent,
    ]
})
export class PpdLookupModule {

}
